import { render } from "./ServerErrorScreen.vue?vue&type=template&id=1a462a52"
import script from "./ServerErrorScreen.vue?vue&type=script&lang=js"
export * from "./ServerErrorScreen.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__